import { Injectable } from '@angular/core';
import { merge } from 'lodash';
import { StorageService } from '../services/storage.service';
import { v4 as uuid } from 'uuid';

@Injectable({
  providedIn: 'root'
})
/*
 *  Adapter zapewniający kompatybilność wsteczną dla storage
 *  Prototyp storage jest nadpisywany przez dane płynące z MMC Storage
 */
export class StorageAdapter {

  constructor(
    private storageService: StorageService,
  ) { }

  /**
   * Adaptacja MMC Storage Heatrock na Storage Heatrock
   * 
   * @param input 
   */
  adapt(input: any) {
    let output: any = {};

    output = merge(this.storageService.storage, input);

    return this.getAdaptedStorage(input, output);
  }

  /**
   * Szczegółowa adaptacja Storage
   * 
   * @param input 
   * @param output 
   */
  getAdaptedStorage(input: any, output: any) {
    return merge(output, {
      current: {
        hash: uuid(),
      }
    });
  }

}
